import PropTypes from 'prop-types'

import { contentPush as cpProps } from '../../../../types'

export const propTypes = {
    countries: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            name: PropTypes.string,
        })
    ).isRequired,
    errors: PropTypes.shape({
        countries: PropTypes.string,
        date_end: PropTypes.string,
        date_start: PropTypes.string,
        group: PropTypes.string,
        level_required: PropTypes.string,
        media: PropTypes.string,
        name: PropTypes.string,
        notes: PropTypes.string,
        purchase_order: PropTypes.string,
    }),
    estates: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            name: PropTypes.string,
        })
    ).isRequired,
    goBack: PropTypes.func,
    isNew: PropTypes.bool,
    levels: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.number,
        })
    ),
    groups: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.number,
        })
    ),
    statusList: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.number,
        })
    ),
    onChange: PropTypes.shape({
        countries: PropTypes.func,
        date_end: PropTypes.func,
        date_start: PropTypes.func,
        group: PropTypes.func,
        level_required: PropTypes.func,
        media: PropTypes.func,
        name: PropTypes.func,
        notes: PropTypes.func,
        purchase_order: PropTypes.func,
    }),
    onChangeDefault: PropTypes.func,
    onChangeEstate: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
    optionsPlaylist: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            value: PropTypes.string,
        })
    ),
    selectedEstate: PropTypes.string.isRequired,
    values: PropTypes.shape(cpProps),
    hadPO: PropTypes.bool,
    isMobile: PropTypes.bool,
}

export const defaultProps = {
    errors: {
        countries: null,
        date_end: null,
        date_start: null,
        group: null,
        level_required: null,
        media: null,
        name: null,
        notes: null,
    },
    goBack: null,
    isNew: false,
    onChange: {},
    onChangeDefault: () => null,
    onSubmit: () => null,
    optionsPlaylist: [],
    values: {
        countries: [],
        date_end: 0,
        date_start: 0,
        group: '',
        level_required: '',
        media: [],
        name: '',
        notes: '',
        purchase_order: '',
    },
    levels: [],
    groups: [],
    hadPO: false,
    isMobile: false,
}
